import React from 'react'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import store from '../state/store'
import DoNotContactWarning from './do_not_contact_warning'
import SelectCannedReply from './emailer/select_canned_reply'

class Smser extends React.Component {

  setContent = (el) => {
    this.contentEl = el
  }

  onChange = () => {
    store.emit('ui:enquiry:smser:content', this.contentEl.value)
  }

  onInsertCannedReply = (body) => {
    const el = this.contentEl

    if (!el) {
      store.emit('ui:enquiry:smser:content', (this.props.value || '') + body)
      return
    }

    const start = el.selectionStart
    const end = el.selectionEnd
    const value = el.value
    const next = value.slice(0, start) + body + value.slice(end)

    store.emit('ui:enquiry:smser:content', next)

    const caret = start + body.length
    window.requestAnimationFrame(() => {
      el.focus()
      el.setSelectionRange(caret, caret)
    })
  }

  onSend = () => {
    store.emit('enquiry:sms:create')
  }

  onClose = () => {
    store.emit('enquiry:sms:close')
  }

  render() {
    return (
      <div className="p-4">
        <DoNotContactWarning show={this.props.do_not_contact} className="mb-4" />
        <Textarea rows="6" placeholder="Write an SMS message..." ref={this.setContent} value={this.props.value} onChange={this.onChange}/>
        <span className="mt-1 block text-xs text-muted-foreground">{(this.props.value || '').length} characters (max. 640)</span>
        <div className="mt-4 flex flex-wrap items-center justify-between">
          <SelectCannedReply onSelect={this.onInsertCannedReply} />
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onClose}>Cancel</Button>
            <Button size="sm" onClick={this.onSend}>Send SMS</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default Smser
